export default __webpack_public_path__ + "static/media/image-placeholder.4122bb5e.png";